import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    const source = event.target.closest("figure > img")
    if (!source) return
    const modal = document.getElementById("knowledge-edit-modal")
    if (!modal) return
    const dialog = document.createElement("div")
    dialog.className = "modal-dialog modal-dialog-centered"
    const content = document.createElement("div")
    content.className = "modal-content"
    const image = document.createElement("img")
    image.src = source.src
    image.alt = source.alt
    content.append(image)
    dialog.append(content)
    modal.replaceChildren(dialog)
    modal.setAttribute("data-coreui-modal-open-value", "true")
  }
}
